import React from 'react';
import classNames from 'classnames';
import styles from '../assets/payroll-actions.module.scss';
import user from '../../../../../../../services/user-auth';
import UserRole from '../../../../../../../enumerables/user-role';
import DeletePayrollAction from './DeletePayrollAction';
import PaidPayrollAction from './PaidPayrollAction';

const PayrollActionsColumn: React.FunctionComponent<any> = ({
    updateState,
    setUpdateState,
    cell: {
        row: { original },
    },
}: any) => {
    return (
        <div className={`${classNames(styles.actions)} `}>
            {original.status !== 3 && user.getRoles().includes(UserRole.ROLE_ADMIN) && (
                <div className={'d-flex'}>
                    <PaidPayrollAction setUpdateState={setUpdateState} updateState={updateState} data={original} />
                    <DeletePayrollAction data={original} />
                </div>
            )}
        </div>
    );
};

export default PayrollActionsColumn;
